import { store } from "../../redux/store";
import fetchServer from "../fetchServer";

export default async function getFlightOfferFarerule(obj, userId) {
  var result = { return: 0, msg: "Error", data: {} };

  const userData = store.getState().user.userData;
  let token = userData?.agent?.token || userData.accessToken;

  let headers = { Authorization: `Bearer ${token}` };

  if (userId) headers["user-id"] = userId;

  await fetchServer({
    method: "POST",
    url: `/product/v1/flight/formattedFareRules`,
    data: obj,
    headers,
  })
    .then((res) => {
      if (res?.status === 200) {
        result = { return: 1, msg: "Successfull", data: res.data.data || {} };
      } else {
        result = {
          return: 0,
          msg:
            res?.data?.error ||
            res?.data?.message ||
            "Fare rules could not be read",
          data: {},
        };
      }
    })
    .catch((err) => {
      console.log("Network Error: ", err);
      result = {
        return: 0,
        msg:
          err?.response?.data?.error ||
          err?.response?.data?.message ||
          "Fare rules could not be read",
        data: {},
      };
    });

  return result;
}
